import { ValidityApplicationPeriod } from '../../components/rule-date-range/validity-application-period-utils';
import { SimplifiedAirFamily } from '../../families/air/model/air-family';

export interface Journey {
  rule: JourneyRule;
  applicability: JourneyApplicability;
  content: JourneyContent;
}

export interface JourneyRule {
  id?: string;
  version?: string | number;
  organization?: string;
  partitionId?: string;
  name: string;
  description?: string;
  active: boolean;
  weight?: number;
}

export interface JourneyApplicability {
  pointOfSales?: Location[];
  marketPairs?: MarketPair[];
  contentTypes?: ContentType[];
  products?: Product[];
  validityApplicationPeriods?: ValidityApplicationPeriod[];
  validityApplicationWeekdays?: string[];
}

export interface JourneyContent {
  scope: JourneyScope;
  subRules: JourneySubRule[];
}

export interface Location {
  name: string;
  id?: string;
}

export interface MarketPair {
  firstMarket: Location;
  secondMarket: Location;
}

export enum JourneyScope {
  Carrier = 'Carrier',
  Route = 'Route',
  Journey = 'FlightsInformation',
  Custom = 'Custom',
  Fare = 'Fare'
}

export enum JourneyContentAction {
  ForceInclude = 'force_include',
  Exclude = 'exclude'
}

export enum ContentType {
  EDIFACT = 'Edifact',
  NDC = 'NDC'
}

export enum Product {
  // Availability
  AVL = 'AVL',
  // Master Pricer Expert
  MPE = 'MPE',
  SP = 'SP',
  // Master Pricer Travelboard
  MP = 'MP',
  // Master Pricer X
  MPX = 'MPX',
  // Master Pricer Instant Search Web Services
  MPISWS = 'ITB'
}

export enum ConnectionType {
  Online = 'Online',
  Interline = 'Interline'
}

export interface JourneySubRule {
  applicability: JourneySubApplicability;
  content: JourneySubContent;
}

export interface JourneySubApplicability {
  carrier?: JourneyCarrier;
  route?: JourneyRoute;
  flightsInformation?: JourneyFlightsInformation;
  fare?: JourneyFare;
}

export interface JourneySubContent {
  action?: JourneyContentAction;
  value?: number;
}

export interface JourneyCarrier {
  carrierInformations?: CarrierData[];
  codeshareInformations?: CodeshareInformation[];
  flightRanges?: FlightRange[];
  connectionType?: ConnectionType;
  segmentPositions?: number[];
  transportModes?: string[];
}

export interface Market {
  market: Location;
  marketPosition?: number;
}

export interface JourneyRoute {
  routeMarkets?: Market[];
  rangeConnectingTime?: RangeConnectingTime;
}

export interface RangeConnectingTime {
  minCT: number;
  maxCT: number;
}

export interface JourneyFlightsInformation {
  flightCategories: JourneyFlightCategory[];
  intracity?: boolean;
}

export interface JourneyFare {
  fareTypeNames?: string[];
  fareTypes: FareType[];
  subFareTypes: FareSubType[];
  fareBasis?: FareBasis;
}

export interface FareBasis {
  contains: string;
}

export enum JourneyFlightCategory {
  NonStop = 'NonStop',
  Direct = 'Direct',
  Cog = 'COG',
  TwoSegmentConnection = 'Connection2',
  ThreeSegmentConnection = 'Connection3',
  FourSegmentConnection = 'Connection4',
  FiveSegmentConnection = 'Connection5'
}

export enum FareType {
  // Public
  RP = 'RP',
  // Private
  RU = 'RU',
  // Corporate
  RW = 'RW'
}

// Under Fare type RU
export enum FareSubType {
  // Tour operator
  TO = 'TO',
  // Consolidator
  CS = 'CS',
  // Visit friend
  VF = 'VF'
}

export interface CodeshareInformation {
  primeData?: CarrierData;
  operatingCarrierData?: CarrierData;
  marketingCarrierData?: CarrierData;
}

export interface CarrierData {
  carrierCode?: string;
  alliance?: string;
  carriersFamily?: SimplifiedAirFamily;
}

export interface FlightRange {
  carrierCode: string;
  startNumber: number;
  endNumber?: number;
  operationalSuffix?: string;
}

export enum TransportMode {
  Air = 'Air',
  Train = 'Train',
  Metro = 'Metro',
  Coach = 'Coach',
  Bus = 'Bus',
  Pedestrian = 'Pedestrian',
  NonAir = 'NonAir'
}
